// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "banner-image-module--base-text-alt--global--006f4";
export var baseTextGlobal = "banner-image-module--base-text--global--25eda";
export var blockSpacing100 = "banner-image-module--block-spacing-100--edb69";
export var blockSpacing50 = "banner-image-module--block-spacing-50--2478c";
export var blockVPadding100 = "banner-image-module--block-v-padding-100--bcd22";
export var blockVPadding50 = "banner-image-module--block-v-padding-50--778c1";
export var body = "banner-image-module--body--c327f";
export var captionTextGlobal = "banner-image-module--caption-text--global--f9bf5";
export var centerCenter = "banner-image-module--centerCenter--20c32";
export var centerTop = "banner-image-module--centerTop--a6747";
export var cmsRenderedContentGlobal = "banner-image-module--cms-rendered-content--global--bbb92";
export var container = "banner-image-module--container--197b4";
export var content = "banner-image-module--content--435ac";
export var contentContainer = "banner-image-module--contentContainer--42f03";
export var contentLeft = "banner-image-module--contentLeft--892c8";
export var contentRight = "banner-image-module--contentRight--be694";
export var dark = "banner-image-module--dark--2adfa";
export var defaultHSpacingGlobal = "banner-image-module--default-h-spacing--global--35176";
export var doubleContainer = "banner-image-module--doubleContainer--dc8fd";
export var doubleContentContainer = "banner-image-module--doubleContentContainer--a0f2a";
export var emptyRight = "banner-image-module--emptyRight--10240";
export var fadeInAnimation = "banner-image-module--fadeInAnimation--80af6";
export var fadeInOnLoadGlobal = "banner-image-module--fade-in-on-load--global--fb15b";
export var fullHeightGlobal = "banner-image-module--full-height--global--03a92";
export var fullHeightOmittingNavGlobal = "banner-image-module--full-height-omitting-nav--global--d87e9";
export var headingTextGlobal = "banner-image-module--heading-text--global--59cf3";
export var image = "banner-image-module--image--e1b90";
export var ingressTextGlobal = "banner-image-module--ingress-text--global--dbd55";
export var leftCenter = "banner-image-module--leftCenter--ca1f8";
export var leftTop = "banner-image-module--leftTop--8a063";
export var light = "banner-image-module--light--f3ccb";
export var link = "banner-image-module--link--d6af1";
export var linkBlack = "banner-image-module--linkBlack--842c7";
export var linkColorChangeTransitionGlobal = "banner-image-module--link-color-change-transition--global--d1422";
export var linkWhite = "banner-image-module--linkWhite--ab112";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "banner-image-module--page-heading-text--global--45249";
export var paragraphTextGlobal = "banner-image-module--paragraph-text--global--47388";
export var subheadingTextGlobal = "banner-image-module--subheading-text--global--1bf0f";
export var title = "banner-image-module--title--89546";